import MedomaLogoIcon from "./SVG/medoma-logo-icon.svg?react";

const LogoIconOnly = () => {
  return <MedomaLogoIcon />;
};

export default LogoIconOnly;
